var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Button, Form, Input, Modal, Select, Space, Table, message } from 'antd';
import React, { useMemo, useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { exportLTVUsersSelected, fetchLTVUsers, formatLtvAsyncExportMessage } from '../../../cores/api/api-dashboard';
import { useQuery } from '@tanstack/react-query';
import { useTableSearchParams } from '../../../cores/hooks/use-search-param';
import { usePagination } from '../../../cores/hooks/use-pagination';
import { filterAllowedParams } from '../../../utils/utils';
import { LABEL_MAP_SEX_STATUS } from '../../../contants/gender';
const yen = v => `¥${v.toLocaleString()}`;
const Option = Select.Option;
const ASYNC_EXPORT_MAX_ROWS = 5000;
const LTV_EXPORT_MODAL_Z_INDEX = 2000;
const RECIPIENT_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function isValidRecipientEmail(email) {
    return RECIPIENT_EMAIL_PATTERN.test(email);
}
const ALLOW_LTV_PARAMS = ['page', 'limit', 'sex', 'email', 'sort_by', 'order'];
export default function SectionLTVChart() {
    var _a;
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isModalOpen = _useState2[0], setIsModalOpen = _useState2[1];
    const _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), isEmailModalOpen = _useState4[0], setIsEmailModalOpen = _useState4[1];
    const _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), isListEmailOpen = _useState6[0], setIsListEmailOpen = _useState6[1];
    const _useState7 = useState(''), _useState8 = _slicedToArray(_useState7, 2), exportDestinationEmail = _useState8[0], setExportDestinationEmail = _useState8[1];
    const _useState9 = useState([]), _useState0 = _slicedToArray(_useState9, 2), selectedRowKeys = _useState0[0], setSelectedRowKeys = _useState0[1];
    const _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), isExporting = _useState10[0], setIsExporting = _useState10[1];
    const _useState11 = useState(null), _useState12 = _slicedToArray(_useState11, 2), exportNotice = _useState12[0], setExportNotice = _useState12[1];
    const _useTableSearchParams = useTableSearchParams({
        page: 1,
        limit: 20
    }), params = _useTableSearchParams.params, updateFilter = _useTableSearchParams.updateFilter, handleTableChange = _useTableSearchParams.handleTableChange;
    const ltvParams = useMemo(() => filterAllowedParams(params, ALLOW_LTV_PARAMS), [params]);
    const _useQuery = useQuery({
        queryKey: ['admin-user-ltvs', ltvParams],
        queryFn: () => fetchLTVUsers(ltvParams),
        keepPreviousData: true
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, isFetching = _useQuery.isFetching;
    const tableData = (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [];
    const pagination = usePagination(data === null || data === void 0 ? void 0 : data.pagination, 20);
    const columns = [{
            title: 'ユーザーID',
            dataIndex: 'user_id',
            key: 'user_id',
            width: 110,
            render: (_, record) => /*#__PURE__*/ React.createElement("a", {
                href: `/userpage?id=${record.user_id}`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "text-blue-600 hover:underline",
                onClick: e => e.stopPropagation()
            }, record.user_id),
            sorter: true,
            sortOrder: params.sort_by === 'user_id' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: 'メールアドレス',
            dataIndex: 'email',
            key: 'email',
            sorter: true,
            sortOrder: params.sort_by === 'email' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: '性別',
            dataIndex: 'sex',
            key: 'sex',
            width: 100,
            sorter: true,
            align: 'center',
            render: value => { var _a; return (_a = LABEL_MAP_SEX_STATUS[value]) !== null && _a !== void 0 ? _a : '-'; }
        }, {
            title: '月額料金',
            dataIndex: 'subscription_amount',
            key: 'subscription_amount',
            width: 160,
            render: v => yen(v),
            sorter: true,
            sortOrder: params.sort_by === 'subscription_amount' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: '入会月',
            dataIndex: 'subscription_start_date',
            key: 'subscription_start_date',
            width: 130,
            align: 'center',
            sorter: true,
            sortOrder: params.sort_by === 'subscription_start_date' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: '解約日',
            dataIndex: 'subscription_end_date',
            key: 'subscription_end_date',
            width: 130,
            align: 'center',
            sorter: true,
            sortOrder: params.sort_by === 'subscription_end_date' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: '継続月数',
            dataIndex: 'active_months',
            key: 'active_months',
            width: 100,
            align: 'center',
            sorter: true,
            sortOrder: params.sort_by === 'active_months' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: 'いいね購入額',
            dataIndex: 'like_purchase_amount',
            key: 'like_purchase_amount',
            width: 160,
            render: v => yen(v),
            sorter: true,
            sortOrder: params.sort_by === 'like_purchase_amount' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: '合計売上',
            dataIndex: 'total_revenue',
            key: 'total_revenue',
            width: 160,
            render: v => yen(v),
            sorter: true,
            sortOrder: params.sort_by === 'total_revenue' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }, {
            title: 'LTV',
            dataIndex: 'ltv',
            key: 'ltv',
            width: 140,
            render: v => yen(Math.round(v)),
            sorter: true,
            sortOrder: params.sort_by === 'ltv' ? params.order === 'asc' ? 'ascend' : 'descend' : undefined
        }];
    const onReset = () => {
        form.resetFields();
    };
    const onFinish = values => updateFilter(values);
    const getExportParams = recipient_email => _objectSpread({
        sex: ltvParams.sex,
        email: ltvParams.email,
        recipient_email,
        sort_by: params.sort_by,
        order: params.order
    }, selectedRowKeys.length > 0 && {
        user_ids: selectedRowKeys.map(Number).filter(Boolean)
    });
    const getEstimatedExportRowCount = () => {
        var _a, _b;
        if (selectedRowKeys.length > 0) {
            return selectedRowKeys.length;
        }
        return (_b = (_a = data === null || data === void 0 ? void 0 : data.pagination) === null || _a === void 0 ? void 0 : _a.total_count) !== null && _b !== void 0 ? _b : 0;
    };
    const downloadCsvFile = (blob, filename) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    const runDirectCsvDownload = () => __awaiter(this, void 0, void 0, function* () {
        setIsExporting(true);
        try {
            const result = yield exportLTVUsersSelected(getExportParams());
            if (result.type === 'email') {
                setExportNotice({
                    row_count: result.row_count,
                    email: result.email,
                    key: Date.now()
                });
                return;
            }
            downloadCsvFile(result.blob, result.filename);
            message.success('CSVをダウンロードしました。');
        }
        catch (err) {
            message.error(err instanceof Error ? err.message : 'CSVのエクスポートに失敗しました。');
        }
        finally {
            setIsExporting(false);
        }
    });
    const openCsvExportFlow = target => {
        if (getEstimatedExportRowCount() > ASYNC_EXPORT_MAX_ROWS) {
            if (target === 'list') {
                setIsListEmailOpen(true);
            }
            else {
                setIsEmailModalOpen(true);
            }
            return;
        }
        void runDirectCsvDownload();
    };
    const closeExportNotice = () => {
        setExportNotice(null);
    };
    const handleConfirmDownloadCsv = () => __awaiter(this, void 0, void 0, function* () {
        if (!exportDestinationEmail.trim()) {
            message.error('メールアドレスを入力してください');
            return;
        }
        setIsExporting(true);
        setIsEmailModalOpen(false);
        setIsListEmailOpen(false);
        setExportDestinationEmail('');
        try {
            const result = yield exportLTVUsersSelected(getExportParams(exportDestinationEmail));
            if (result.type === 'email') {
                setExportNotice({
                    row_count: result.row_count,
                    email: result.email,
                    key: Date.now()
                });
                return;
            }
            message.error('メール送信でのエクスポートが開始できませんでした。しばらくしてから再度お試しください。');
        }
        catch (err) {
            message.error(err instanceof Error ? err.message : 'CSVのエクスポートに失敗しました。');
        }
        finally {
            setIsExporting(false);
        }
    });
    const rowSelection = {
        selectedRowKeys,
        onChange: keys => setSelectedRowKeys(keys),
        preserveSelectedRowKeys: true
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "by-user mt-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-4 mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-4xl font-bold"
    }, "\u30E6\u30FC\u30B6\u30FC\u58F2\u4E0A"), /*#__PURE__*/ React.createElement(Button, {
        type: "default",
        onClick: () => setIsModalOpen(true)
    }, "\u3055\u3089\u306B\u898B\u308B"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        icon: /*#__PURE__*/ React.createElement(DownloadOutlined, null),
        onClick: () => openCsvExportFlow('main'),
        loading: isExporting,
        disabled: isExporting
    }, "CSV\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9")), /*#__PURE__*/ React.createElement(Table, {
        rowKey: (record, index) => record.user_id != null ? String(record.user_id) : `row-${index}`,
        size: "middle",
        dataSource: tableData,
        columns: columns,
        loading: isLoading || isFetching,
        pagination: false,
        bordered: true,
        onChange: handleTableChange
    }), /*#__PURE__*/ React.createElement(Modal, {
        title: "\u30E6\u30FC\u30B6\u30FC\u58F2\u4E0A",
        open: isModalOpen,
        onCancel: () => {
            setIsModalOpen(false);
            setSelectedRowKeys([]);
        },
        width: "94vw",
        footer: null,
        closable: true,
        zIndex: LTV_EXPORT_MODAL_Z_INDEX
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 flex justify-end border border-gray-300 pt-4 px-4 rounded-[8px] bg-gray-100"
    }, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        onFinish: onFinish
    }, /*#__PURE__*/ React.createElement(Space, {
        wrap: true,
        size: "large",
        align: "end"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u6027\u5225",
        name: "sex"
    }, /*#__PURE__*/ React.createElement(Select, {
        allowClear: true,
        style: {
            width: 100
        }
    }, /*#__PURE__*/ React.createElement(Option, {
        value: "1"
    }, "\u7537\u6027"), /*#__PURE__*/ React.createElement(Option, {
        value: "2"
    }, "\u5973\u6027"))), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        name: "email"
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "example@email.com",
        style: {
            width: 260
        },
        allowClear: true
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: ""
    }, /*#__PURE__*/ React.createElement(Space, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: onReset
    }, "\u30EA\u30BB\u30C3\u30C8"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit"
    }, "\u691C\u7D22"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        icon: /*#__PURE__*/ React.createElement(DownloadOutlined, null),
        onClick: () => openCsvExportFlow('list'),
        loading: isExporting,
        disabled: isExporting
    }, selectedRowKeys.length > 0 ? `CSVダウンロード (${selectedRowKeys.length}件)` : 'CSVダウンロード')))))), /*#__PURE__*/ React.createElement(Table, {
        rowKey: (record, index) => record.user_id != null ? String(record.user_id) : `row-${index}`,
        rowSelection: rowSelection,
        dataSource: tableData,
        columns: columns,
        scroll: {
            y: 500
        },
        bordered: true,
        loading: isLoading || isFetching,
        size: "middle",
        onChange: handleTableChange,
        pagination: _objectSpread(_objectSpread({}, pagination), {}, {
            current: params.page
        }),
        showSorterTooltip: false
    })), /*#__PURE__*/ React.createElement(Modal, {
        title: "CSV\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
        open: isEmailModalOpen || isListEmailOpen,
        onOk: handleConfirmDownloadCsv,
        onCancel: () => {
            setIsEmailModalOpen(false);
            setIsListEmailOpen(false);
            setExportDestinationEmail('');
        },
        okText: "\u78BA\u5B9A",
        centered: true,
        zIndex: LTV_EXPORT_MODAL_Z_INDEX + 1
    }, /*#__PURE__*/ React.createElement(Form, {
        layout: "vertical"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u9001\u4FE1\u5148\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        required: true
    }, /*#__PURE__*/ React.createElement(Input, {
        value: exportDestinationEmail,
        onChange: e => setExportDestinationEmail(e.target.value),
        placeholder: "example@example.com"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "text-sm text-gray-500"
    }, "CSV\u306F\u30B7\u30B9\u30C6\u30E0\u306B\u3088\u308A\u81EA\u52D5\u751F\u6210\u3055\u308C\u3001\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3078\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002"))), /*#__PURE__*/ React.createElement(Modal, {
        key: exportNotice === null || exportNotice === void 0 ? void 0 : exportNotice.key,
        title: "CSV\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
        open: !!exportNotice,
        zIndex: LTV_EXPORT_MODAL_Z_INDEX,
        onOk: closeExportNotice,
        onCancel: closeExportNotice,
        okText: "OK",
        cancelButtonProps: {
            style: {
                display: 'none'
            }
        },
        centered: true,
        maskClosable: false
    }, exportNotice && /*#__PURE__*/ React.createElement("div", {
        className: "whitespace-pre-line"
    }, formatLtvAsyncExportMessage(exportNotice.row_count, exportNotice.email))));
}
